// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Wu","author":"e_Xu","container":"e_Yu","image":"e_Zu","uiHolder":"e__u"};